import { render } from "./ResponsiveTable.vue?vue&type=template&id=59fd5ac2&scoped=true"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js"

import "./ResponsiveTable.vue?vue&type=style&index=0&id=59fd5ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fd5ac2"]])

export default __exports__